export const baseURL = process.env.VUE_APP_URL
export const pdfURL = process.env.VUE_APP_PDFURL
export const load_pdfURL = process.env.VUE_APP_LOAD_PDFURL